const GoogleAnalyticsScreenTitles = {
    PAYMENT_PLANS_VIEW: "Payment Plans View",
    PREQUAL_AGREE: "Prequalify Agree",
    TERMS: "Terms",
    PLANS: "Plans",
    START: "Start",
    APPLY: "Apply",
    PAYMENT_PLANS: "Payment Plans",
    PAYMENT_PLAN_REVIEW: "PaymentPlanReview",
    CHECK_CALIFORNIA: "Check California",
    PENDING: "Pending",
    APPROVED: "Approved",
    DECLINED: "Declined"
}

export default GoogleAnalyticsScreenTitles


